import { dynamicApiSlice } from "../dynamicApi";

export interface ProceedArgs {
  workflowInstanceId: string;
  workflowStepInstanceId: string;
}

export const workflowStepInstanceApi = dynamicApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    proceedWithOutputs: builder.mutation<void, ProceedArgs>({
      query: ({ workflowInstanceId, workflowStepInstanceId }) => ({
        url: `workflow-instance/${workflowInstanceId}/step/${workflowStepInstanceId}/proceed-with-outputs`,
        method: "POST",
      }),
    }),
    proceedWithAdditionalInformation: builder.mutation<void, ProceedArgs>({
      query: ({ workflowInstanceId, workflowStepInstanceId }) => ({
        url: `workflow-instance/${workflowInstanceId}/step/${workflowStepInstanceId}/proceed-with-additional-information`,
        method: "POST",
      }),
    }),
    retryWorkflowStep: builder.mutation<void, ProceedArgs>({
      query: ({ workflowInstanceId, workflowStepInstanceId }) => ({
        url: `workflow-instance/${workflowInstanceId}/step/${workflowStepInstanceId}/retry-failed-step`,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useProceedWithOutputsMutation,
  useProceedWithAdditionalInformationMutation,
  useRetryWorkflowStepMutation,
} = workflowStepInstanceApi;
